import React from 'react';
import ReactDOM from 'react-dom';
import Dialog from './dialog.jsx';

import FormattedMessage from '@/intl/formatted-message';
import buttonMessages from '../../../intl/messages/button';
import containnerText6 from '../../../intl/messages/container/part6';
import { formatMessage } from '../../../intl/helper';

import './confirm-dialog.scss';

export default class ConfirmDialog extends React.Component {
  static propTypes = {
    cancelText: React.PropTypes.any,
    confirmText: React.PropTypes.any,
    children: React.PropTypes.any,
    onCancel: React.PropTypes.func,
    onConfirm: React.PropTypes.func,
    onClose: React.PropTypes.func,
    noPreventScrollClassNameList: React.PropTypes.array,
    needPreventScrollDefault: React.PropTypes.bool,
    button: React.PropTypes.array,
  }

  static defaultProps = {
    title: '',
    confirmText: <FormattedMessage {...buttonMessages.confirm} />,
    cancelText: <FormattedMessage {...buttonMessages.cancel} />,
  }

  onConfirm = (evt) => {
    if (evt) {
      evt.preventDefault();
    }

    if (this.props.onConfirm) {
      this.props.onConfirm();
    }
  }

  onCancel = (evt) => {
    if (evt) {
      evt.preventDefault();
    }

    if (this.props.onCancel) {
      this.props.onCancel();
    }
  }

  render() {
    const { cancelText, confirmText, title, button } = this.props;
    const buttons = button || [
      {
        text: cancelText || <FormattedMessage {...buttonMessages.cancel} />,
        className: 'dialog-btn-cancel',
        onClick: this.onCancel,
      },
      {
        text: confirmText || <FormattedMessage {...buttonMessages.confirm} />,
        className: 'dialog-btn-confirm',
        onClick: this.onConfirm,
      },
    ];

    return (
      <Dialog
        title={title}
        theme="sliver"
        onClose={this.props.onClose || this.onCancel}
        buttons={buttons}
        className={`confirm-dialog${title ? '' : ' dialog-no-header'}${buttons.length === 1 ? ' dialog-one-btn' : ''}`}
        noPreventScrollClassNameList={this.props.noPreventScrollClassNameList}
        needPreventScrollDefault={this.props.needPreventScrollDefault}
      >
        {this.props.children}
      </Dialog>
    );
  }
}

export function confirm({
  title,
  content,
  cancelText,
  confirmText,
  onClose,
  onCancel,
  onConfirm,
  isBeforeMap, // 是否获取用户地址
  ...rest,
}) {
  let closed = false;

  const div = document.createElement('div');
  document.body.appendChild(div);

  function close() {
    closed = true;
    ReactDOM.unmountComponentAtNode(div);
    if (div && div.parentNode) {
      div.parentNode.removeChild(div);
    }
  }

  function onPress(action) {
    if (closed) {
      return;
    }

    const res = action ? action() : false;
    if (res && res.then) {
      res.then(close);
    } else {
      close();
    }
  }

  const buttons = isBeforeMap ? [
    {
      text: <FormattedMessage {...containnerText6.UserLoginApplicationiKnown} />,
      className: 'dialog-btn-return',
      onClick: e => {
        e.preventDefault();
        onPress(onConfirm);
      },
    }
  ] : [
    {
      text: cancelText || <FormattedMessage {...buttonMessages.cancel} />,
      className: 'dialog-btn-cancel',
      onClick: e => {
        e.preventDefault();
        onPress(onCancel);
      },
    },
    {
      text: confirmText || <FormattedMessage {...buttonMessages.confirm} />,
      className: 'dialog-btn-confirm',
      onClick: e => {
        e.preventDefault();
        onPress(onConfirm);
      },
    },
  ];

  const con = isBeforeMap ? (<div className="dislog-tip-map">
      <p className="tit">{formatMessage(containnerText6.warmTip)}</p>
      <div className="des">
        {sessionStorage.getItem('commercialName')}{formatMessage(containnerText6.getYourLocation)}
      </div>
    </div>) : content;

  ReactDOM.render(
    <Dialog
      title={title}
      theme="sliver"
      onClose={onClose}
      buttons={buttons}
      className={`confirm-dialog${title ? '' : ' dialog-no-header'}${isBeforeMap ? ' dialog-one-btn' : ''}`}
      zIndexTop={true}
      {...rest}
    >
      {con}
    </Dialog>,
    div
  );

  return {
    close,
  };
}



// WEBPACK FOOTER //
// ./src/component/mui/dialog/confirm-dialog.jsx